import { Col, Row } from "react-bootstrap";
import LicenceProfileHeader from "../LicenceProfileHeader";
import LicenceProfileSubTabs from "../LicenceProfileSubTabs";
import BreadCrumbs from "./BreadCrumbs";
import { useParams } from "react-router-dom";
import RelatedComplianceRecords from "./RelatedComplianceRecords";
import Page404 from "../../../pages/auth/Page404";
import useAppSelector from "../../../hooks/useAppSelector";
import {
  loadLicenceProfileAsync,
  selectLicenceProfileResponse,
} from "../../../redux/slices/licenceProfile";
import useAppDispatch from "../../../hooks/useAppDispatch";
import Loading from "../../../leap-components/Loading";
import BackToCompliance from "../ComplianceTab/BackToCompliance";
import { useState } from "react";
import {
  GetLicenceProfileNotReadyComponent,
  IsLicenceProfileReady,
} from "../../../leap-components/LicenceProfile/LicenceProfileResponseComponentFactory";
import { ILicenceProfile } from "../../../api/LicenceProfile";
import EdenMessageHeader from "./EdenMessageHeader";
import EdenMessageDetails from "./EdenMessageDetails";
import {
  loadEdenMessageAsync,
  selectEdenMessage,
} from "../../../redux/slices/edenMessage";

const EdenMessage = () => {
  const [loading, setLoading] = useState(false);
  const [loadingMessageById, setLoadingMessageById] = useState("");

  const licenceProfileSelector = useAppSelector(selectLicenceProfileResponse);
  const edenMessageSelector = useAppSelector(selectEdenMessage);

  const dispatch = useAppDispatch();

  let { profileNo, edenMessageId } = useParams();
  if (!profileNo || !edenMessageId) {
    return <Page404 />;
  }

  if (!loading) {
    setLoading(true);
    dispatch(loadLicenceProfileAsync(profileNo));
  }

  if (!IsLicenceProfileReady(licenceProfileSelector.licenceProfileResponse)) {
    return GetLicenceProfileNotReadyComponent(
      licenceProfileSelector.licenceProfileResponse
    );
  }

  const licenceProfile = licenceProfileSelector.licenceProfileResponse
    ?.licenceProfile as ILicenceProfile;

  if (edenMessageId !== loadingMessageById) {
    setLoadingMessageById(edenMessageId);
    dispatch(loadEdenMessageAsync(edenMessageId));
    return <Loading />;
  }

  const edenMessage = edenMessageSelector.edenMessage;

  if (!edenMessage) {
    return <Loading />;
  }

  const contentElement = (
    <div>
      <Row>
        <Col className="col-12 col-md-12">
          <BackToCompliance profileNo={profileNo} />
        </Col>
      </Row>
      <Row>
        <Col className="col-12 col-sm-12 col-md-12">
          <EdenMessageHeader
            licenceProfile={licenceProfile}
            edenMessage={edenMessage}
          />
        </Col>
      </Row>
      <Row>
        <Col className="col-12 col-sm-12 col-md-12">
          <EdenMessageDetails edenMessage={edenMessage} />
        </Col>
      </Row>
      <Row>
        <Col className="col-12 col-md-12">
          <BackToCompliance profileNo={profileNo} />
        </Col>
      </Row>
      <Row>
        <Col className="col-12 col-sm-12 col-md-12">
          <RelatedComplianceRecords edenMessage={edenMessage} />
        </Col>
      </Row>
    </div>
  );

  return (
    <div>
      <BreadCrumbs licenceProfile={licenceProfile} edenMessage={edenMessage} />
      <div className="ps-0">
        <LicenceProfileHeader licenceProfile={licenceProfile} />
        <LicenceProfileSubTabs
          activeKey="compliance-records"
          content={contentElement}
          licenceProfile={licenceProfile}
        />
      </div>
    </div>
  );
};

export default EdenMessage;
